import { ArrowCircle } from "@lhd/assets";
import ButtonVertical from "../ButtonVertical";

type Props = React.ComponentProps<typeof ButtonVertical> & {
  directionArrow: "up" | "down" | "left" | "right";
};

const ButtonVerticalCollapse = ({ directionArrow, ...restProps }: Props) => {
  return (
    <ButtonVertical
      {...restProps}
      icon={restProps.icon || <ArrowCircle direction={directionArrow} />}
    >
      {restProps.children || "閉"}
    </ButtonVertical>
  );
};

export default ButtonVerticalCollapse;
